// extracted by mini-css-extract-plugin
module.exports = {"info":"_1KHxz","time":"_3KGJN","title":"_1tTy_","ellipsis":"q-O22","more":"_1CkT5"};